import { getAuthHeaders, urlMap } from '../utils';

function parseFileNameFromDisposition(disposition) {
  if (!disposition) return null;
  const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) return decodeURIComponent(utf8Match[1]);
  const basicMatch = disposition.match(/filename="?([^";]+)"?/i);
  return basicMatch?.[1] || null;
}

function triggerBlobDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || 'draft.pdf';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

async function downloadPdf(url, withAuth = false) {
  const res = await fetch(url, {
    method: 'GET',
    headers: {
      ...(withAuth ? getAuthHeaders() : {}),
    },
  });

  if (!res.ok) {
    throw new Error(`Failed to export PDF (${res.status})`);
  }

  const blob = await res.blob();
  const fromHeader = parseFileNameFromDisposition(res.headers.get('content-disposition'));
  triggerBlobDownload(blob, fromHeader || 'draft.pdf');
}

export async function exportChapterPdf(chapterId) {
  if (!chapterId) throw new Error('Missing chapter id for PDF export.');
  await downloadPdf(urlMap.exportChapterPdf(chapterId), true);
}

export async function exportProjectProofOfWorkPdf(projectId) {
  if (!projectId) throw new Error('Missing project id for PDF export.');
  await downloadPdf(urlMap.exportProjectProofOfWorkPdf(projectId), true);
}
